import { useEffect, useState } from "react";
import { Leaf, TrainFront } from "lucide-react";
import api from "../../lib/api";

/* Trip carbon footprint — estimated CO2 for the trip's flight legs with
   greener-route suggestions (direct vs connection, train for short hops). */
export default function TripCarbon({ trip }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/carbon/trip/${trip.id}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [trip.id, trip.segments]);

  if (!data || !data.legs?.length) return null;

  return (
    <section className="mb-10" data-testid="trip-carbon">
      <div className="border border-emerald-300 bg-emerald-50/60">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 sm:px-5">
          <h3 className="font-heading font-900 text-emerald-800 text-lg inline-flex items-center gap-2">
            <Leaf className="w-5 h-5" /> Carbon footprint
          </h3>
          <span className="font-heading font-900 text-2xl text-emerald-900" data-testid="trip-carbon-total">
            ~{data.total_kg.toLocaleString()} kg CO2
          </span>
          <span className="text-sm text-emerald-800">
            per traveller · {data.trees_year} trees absorb this in a year · like driving {data.car_km.toLocaleString()} km
          </span>
        </div>
        <div className="flex flex-wrap gap-2 border-t border-emerald-200 bg-white/70 px-4 py-2.5 sm:px-5">
          {data.legs.map((leg) => (
            <span key={leg.segment_id} data-testid={`trip-carbon-leg-${leg.segment_id}`}
              className="inline-flex items-center gap-1.5 border border-emerald-200 bg-white px-2.5 py-1 text-xs text-zinc-700"
              title={`${leg.distance_km.toLocaleString()} km ${leg.haul}`}>
              <span className="font-700">{leg.dep} → {leg.arr}</span>
              <span className="text-emerald-700 font-600">~{leg.co2_kg} kg</span>
            </span>
          ))}
        </div>
        {data.suggestions?.length > 0 && (
          <ul className="border-t border-emerald-200 px-4 py-2.5 sm:px-5 space-y-1" data-testid="trip-carbon-suggestions">
            {data.suggestions.map((s, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-emerald-900">
                <TrainFront className="w-4 h-4 mt-0.5 shrink-0 text-emerald-700" /> {s}
              </li>
            ))}
          </ul>
        )}
        <p className="border-t border-emerald-200 px-4 py-1.5 sm:px-5 text-[11px] text-emerald-700/80">
          Estimate: great-circle distance with ICAO/DEFRA-style per-km emission factors, economy cabin.
        </p>
      </div>
    </section>
  );
}
